import React from 'react';
import { ActivityPost } from '@components/feed/Feed/components/ActivityPost';
import { ICompetitionPublishedActivity } from './interfaces';
import { Trans } from 'react-i18next';
import { useNavigate } from 'react-router';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import { CompetitionActivityBody } from '../components/CompetitionActivityBody';
import { getPortalCompetitionDetailsRoute } from '../helpers';

export const CompetitionPublishedActivity: React.FC<
  ICompetitionPublishedActivity
> = (props): JSX.Element => {
  const navigate = useNavigate();
  const detailsRoute = getPortalCompetitionDetailsRoute(props.slug, props.status);

  const activityTitle = (
    <Trans
      i18nKey={'activities:competitionPublished.title'}
      values={{
        title: props.title,
      }}
      components={{
        bold: <strong />,
      }}
    />
  );

  return (
    <ActivityPost
      title={activityTitle}
      date={props.date}
      icon={EmojiEventsIcon}
      onClick={() => navigate(detailsRoute)}
    >
      <CompetitionActivityBody {...props} variant="published" />
    </ActivityPost>
  );
};
